import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=501dd330&scoped=true"
import script from "./QuotesList.vue?vue&type=script&lang=js"
export * from "./QuotesList.vue?vue&type=script&lang=js"
import style0 from "./QuotesList.vue?vue&type=style&index=0&id=501dd330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501dd330",
  null
  
)

export default component.exports